import useStrategies from './useStrategies';
import { LOCATION } from 'src/hooks/filters/constants';

/**
 * Hook to access metric toggles functionality
 * Uses the existing useStrategies hook to maintain consistency
 */
const useMetricToggles = () => {
  const { metricToggles, setMetricToggle } = useStrategies(LOCATION.STRATEGY_CENTER);
  
  return {
    metricToggles,
    setMetricToggle,
  };
};

export default useMetricToggles;